<template>
  <component :is="component"
             class="app-icon"
             :class="modifiers"
  />
</template>

<script>
import IconAddToRoute from "@/components/common/AppIcon/icons/IconAddToRoute.vue";
import IconArrowDownTriangle from "@/components/common/AppIcon/icons/IconArrowDownTriangle.vue";
import IconArrowLeft from "@/components/common/AppIcon/icons/IconArrowLeft.vue";
import IconArrowRight from "@/components/common/AppIcon/icons/IconArrowRight.vue";
import IconArrowRightDouble from "@/components/common/AppIcon/icons/IconArrowRightDouble.vue";
import IconClose from "@/components/common/AppIcon/icons/IconClose.vue";
import IconDragHandle from "@/components/common/AppIcon/icons/IconDragHandle.vue";
import IconFeedback from "@/components/common/AppIcon/icons/IconFeedback.vue";
import IconFlag from "@/components/common/AppIcon/icons/IconFlag.vue";
import IconGear from "@/components/common/AppIcon/icons/IconGear.vue";
import IconHelp from "@/components/common/AppIcon/icons/IconHelp.vue";
import IconIsInRoute from "@/components/common/AppIcon/icons/IconIsInRoute.vue";
import IconMagnifier from "@/components/common/AppIcon/icons/IconMagnifier.vue";
import IconMap from "@/components/common/AppIcon/icons/IconMap.vue";
import IconPdf from "@/components/common/AppIcon/icons/IconPdf.vue";
import IconPencil from "@/components/common/AppIcon/icons/IconPencil.vue";
import IconRollback from "@/components/common/AppIcon/icons/IconRollback.vue";
import IconRouteMarkerTemplate from "@/components/common/AppIcon/icons/IconRouteMarkerTemplate.vue";
import IconRouteMarkerTemplateEditable from "@/components/common/AppIcon/icons/IconRouteMarkerTemplateEditable.vue";
import IconRouteMarkerTemplateNew from "@/components/common/AppIcon/icons/IconRouteMarkerTemplateNew.vue";
import IconRouteNewCoordinate from "@/components/common/AppIcon/icons/IconRouteNewCoordinate.vue";
import IconRouteSmall from "@/components/common/AppIcon/icons/IconRouteSmall.vue";
import IconSave from "@/components/common/AppIcon/icons/IconSave.vue";
import IconShelf from "@/components/common/AppIcon/icons/IconShelf.vue";
import IconTimelineLabel from "@/components/common/AppIcon/icons/IconTimelineLabel.vue";
import IconTrashCan from "@/components/common/AppIcon/icons/IconTrashCan.vue";

export default {
  name: "AppIcon",
  components: {
    IconAddToRoute,
    IconArrowDownTriangle,
    IconArrowLeft,
    IconArrowRight,
    IconArrowRightDouble,
    IconClose,
    IconDragHandle,
    IconFeedback,
    IconFlag,
    IconGear,
    IconHelp,
    IconIsInRoute,
    IconMagnifier,
    IconMap,
    IconPdf,
    IconPencil,
    IconRollback,
    IconRouteMarkerTemplate,
    IconRouteMarkerTemplateEditable,
    IconRouteMarkerTemplateNew,
    IconRouteNewCoordinate,
    IconRouteSmall,
    IconSave,
    IconShelf,
    IconTimelineLabel,
    IconTrashCan
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isHoverable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    component() {
      return `icon-${ this.icon }`
    },
    modifiers() {
      return {
        'app-icon--is-active': this.isActive,
        'app-icon--is-hoverable': this.isHoverable
      }
    }
  }
}
</script>

<style lang="scss">
.app-icon {
  color: $app-primary-color;
  transition: color .3s;

  &--is-hoverable:hover,
  &--is-active {
    color: $app-primary-accent-color;
  }
}

.btn {
  .app-icon {
    color: #FFFFFF;
  }

  &:not(.btn-icon) {
    .app-icon {
      width: 1em;
      height: 1em;
      margin-right: 4px;
      margin-bottom: -2px;
    }
  }
}
</style>